import { render, staticRenderFns } from "./ImportDNAS.vue?vue&type=template&id=8587df70&"
import script from "./ImportDNAS.vue?vue&type=script&lang=js&"
export * from "./ImportDNAS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports